import { Segmented } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllConditionsListSlice } from 'src/modules/SuperAdmin/store/slices';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import PreBuiltTemplatesPage from './PreBuiltTemplates/PreBuiltTemplates.page';
import TemplatesAdminPage from './TemplatesAdmin/TemplatesAdmin.page';
import TemplatesExchangeAdminPage from './TemplatesExchangeAdmin/TemplatesExchangeAdmin.page';
import TemplatesSpecialtiesPage from './TemplatesAdmin/TemplateSpecialties';
import PreBuiltTemplateAdminPage from './PreBuiltTemplateAdmin/PreBuiltTemplateAdmin.page';

const Templates = ({ isMinimized }) => {
  const [activeButton, setActiveButton] = useState(() => {
    return (
      getFromStorage('superAdminTemplatesSegment') ||
      'Pre-built templates Per Plan'
    );
  });
  const dispatch = useDispatch();

  const superAdminButton = [
    {
      label: 'Templates admin',
      isActive: activeButton === 'Templates admin',
      onClick: () => setActiveButton('Templates admin'),
    },
    {
      label: 'Templates exchange admin',
      isActive: activeButton === 'Templates exchange admin',
      onClick: () => setActiveButton('Templates exchange admin'),
    },
    // NOTE: There is no corresponding page defined for this button here
    // {
    //   label: 'Pre-built templates Admin',
    //   isActive: activeButton === 'Pre-built templates Admin',
    //   onClick: () => setActiveButton('Pre-built templates Admin'),
    // },
    {
      label: 'Pre-built templates Per Plan',
      isActive: activeButton === 'Pre-built templates Per Plan',
      onClick: () => setActiveButton('Pre-built templates Per Plan'),
    },
    {
      label: 'Pre-built templates Per Specialty',
      isActive: activeButton === 'Pre-built templates Per Specialty',
      onClick: () => setActiveButton('Pre-built templates Per Specialty'),
    },
    {
      label: 'Pre-built templates Per Org',
      isActive: activeButton === 'Pre-built templates Per Org',
      onClick: () => setActiveButton('Pre-built templates Per Org'),
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    dispatch(getAllConditionsListSlice(null));
    storeInLocal('superAdminTemplatesSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={superAdminButton.map((button) => ({
            label: button.label,
            value: button.label,
          }))}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {activeButton === 'Pre-built templates Per Plan' && (
          <PreBuiltTemplatesPage />
        )}
        {activeButton === 'Templates admin' && <TemplatesAdminPage />}
        {activeButton === 'Pre-built templates Per Specialty' && (
          <TemplatesSpecialtiesPage />
        )}
        {activeButton === 'Templates exchange admin' && (
          <TemplatesExchangeAdminPage />
        )}
        {activeButton === 'Pre-built templates Per Org' && (
          <PreBuiltTemplateAdminPage />
        )}
      </div>
    </div>
  );
};

export default Templates;
